var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_2740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 8.75V14C52 18.8344 40.358 22.75 26 22.75C11.642 22.75 0 18.8344 0 14V8.75C0 3.91562 11.642 0 26 0C40.358 0 52 3.91562 52 8.75ZM45.6393 23.4828C48.0536 22.6734 50.2705 21.6344 52 20.3547V31.5C52 36.3344 40.358 40.25 26 40.25C11.642 40.25 0 36.3344 0 31.5V20.3547C1.72946 21.6453 3.94643 22.6734 6.36071 23.4828C11.5723 25.2328 18.5134 26.25 26 26.25C33.4866 26.25 40.4277 25.2328 45.6393 23.4828ZM0 37.8547C1.72946 39.1453 3.94643 40.1734 6.36071 40.9828C11.5723 42.7328 18.5134 43.75 26 43.75C33.4866 43.75 40.4277 42.7328 45.6393 40.9828C48.0536 40.1734 50.2705 39.1344 52 37.8547V47.25C52 52.0844 40.358 56 26 56C11.642 56 0 52.0844 0 47.25V37.8547Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_2740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseBig);
export default __webpack_public_path__ + "static/media/databaseBig.d99f4176730ff0fdfc0fdebf88ffeab0.svg";
export { ForwardRef as ReactComponent };